import { apiRequest } from "@/utils/api";
import { API_ENDPOINTS } from "@/config/api";
import { Assessment } from "@/types";

export interface DashboardStats {
  total_assessments: {
    count: number;
    increase_this_month: number;
  };
  active_candidates: {
    count: number;
    increase_this_week: number;
  };
  average_score: {
    score: number;
    percentage_change_last_week: number;
  };
  completion_rate: {
    rate: number;
    percentage_change_last_week: number;
  };
  recent_assessments: Assessment[];
}

export async function getDashboardStats(teamId: string): Promise<DashboardStats> {
  return apiRequest<DashboardStats>(`${API_ENDPOINTS.dashboard.stats}?team_id=${teamId}`);
}
